import * as React from "react";
import Component from "../../AbstractComponent";
import { Attachment } from "../../Partials/Attachment/Attachment";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import PersonLookup from "../../Partials/Lookup/PersonLookup";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { Timeline } from "../../Partials/Timeline/Timeline";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";
import ActivityUpdateWillMount from "../../../Middleware/Middlewares/ActivityUpdateWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { BalanceComponent } from "../../Partials/Balance/BalanceComponent";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Time from "../../../Time/Time";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { TableComponent } from "../../Partials/Table/TableComponent";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Charge } from "../../../Entity/Entities/Charge/Charge";
import { Event } from "../../../Entity/Entities/Event/Event";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChargeCreateDialog from "../../Partials/Dialog/ChargeCreateDialog";
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import CoachNewCharge from "../../Partials/Dialog/CoachNewCharge";

class ActivityUpdate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_ACTIVITY_UPDATE_CLEAR;
  protected currentTask;
  protected middlewares: MiddlewareInterface[] = [
    ActivityUpdateWillMount,
    PreventPageLeave
  ];

  public state = {
    activity: null,
    name: "",
    selectedEntityForActivity: null,
    disableObjectField: true,
    ownerId: null,
    tenantId: null,
    reporterId: null,
    subject: "",
    description: "",
    attachments: [],
    amazonFolderName: "",
    events: [],
    tasks: [],
    removed: false,
    reacted: false,
    deletedCharge: null,
    removedPayments: [],
    charges: [],
    selectedTabIndex: 0,
    fetchingEvents: true,
    fetchingTasks: true,
    owner: null,
    tenant: null,
    nextPath: "",
    hasModifiedData: false,
    isSaving: false,
    openLeavePrompt: false,
    isCloseActivityPopupOpen: false,
    anchorElTask: null,
    isDeleteTaskPopupOpen: false,
    currentTask: null,
    anchorElActivity: null,
    isDeleteActivityPopupOpen: false,
    isFetchingActivity: true,
    isChargeCreatePopupOpen: false,
    isCoachNewChargeOpen: false,
    isNewTaskPopupOpen: false
  };

  constructor(public props) {
    super(props);
  }

  public initializePage = (activity: EventInterface) => {
    let state: any = {
      activity: activity,
      name: activity && activity.content && activity.content.name,
      selectedEntityForActivity: null,
      disableObjectField: true,
      reporterId: activity && activity.reporterId,
      subject: activity && activity.content && activity.content.subject,
      description: activity && activity.content && activity.content.description,
      attachments: !!activity ?  activity.attachments : [],
      removed: !!activity ? activity.removed : false,
      reacted: !!activity ? activity.reacted : false,
      activeTemplate: null,
      isFetchingActivity: false
    };

    if (!!activity.property) {
      state.selectedEntityForActivity = activity.property;
      state.ownerId = activity.property.companyId;
      state.owner = activity.property.company;
    }

    if (!!activity.unit) {
      state.selectedEntityForActivity = activity.unit;
      state.tenantId = activity.unit.getActiveContract() && activity.unit.getActiveContract().person && activity.unit.getActiveContract().person.id;
      state.tenant = activity.unit.getActiveContract() && activity.unit.getActiveContract().person;
    }

    if (Object.keys(this.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdReporter = this.props.app.savedDataBeforeRedirecting.reporter &&
        this.props.app.savedDataBeforeRedirecting.reporter;

      state = {
        ...state,
        ...this.props.app.savedDataBeforeRedirecting.activityUpdateDataToBeSaved,
      };

      if (!!createdReporter) {
        state.reporterId = createdReporter.id;
      }
    }

    this.setState({...state}, () => {
      this.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
      });
    });

    this.fetchEntityEvents(activity.id);
  }

  public fetchEntityEvents = (entityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        refersToEventId: entityId
      },
      onSuccess: data => {
        const activityEvents: EventInterface[] = data.events
          .filter((event: EventInterface) => !event.removed);
        this.setState({
          events: [...activityEvents],
          fetchingEvents: false
        });
      }
    });
  }

  public selectReporter = (person: PersonInterface, isManuallySelected: boolean): void => {
    this.setState({
      reporterId: person.id,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData,
    });
  }

  public clearReporter = (): void => {
    this.setState({
      reporterId: null,
      hasModifiedData: true
    });
  }

  public selectEntityForActivity = (entity: PropertyInterface | UnitInterface): void => {
    let tenantId;
    let ownerId;

    if (entity instanceof Property) {
      ownerId = entity.company && entity.companyId;
    }

    if (entity instanceof Unit) {
      tenantId = entity.getActiveContract() && entity.getActiveContract().person && entity.getActiveContract().person.id;
    }

    this.setState({
      tenantId: tenantId,
      ownerId: ownerId,
      selectedEntityForActivityManuallyChanged: true,
      selectedEntityForActivity: entity,
      hasModifiedData: true
    });
  }

  public clearEntityForActivity = (): void => {
    this.setState({
      selectedEntityForActivity: null,
      hasModifiedData: true
    });
  }

  public save = (status) => {
    const activity: any = {
      eventTypeId: 34,
      reacted: this.state.reacted,
      reporterId: this.state.reporterId,
      content: {
        name: this.state.name,
        subject: this.state.subject,
        description: this.state.description
      },
      amazonFolderName: this.state.amazonFolderName,
      id: this.state.activity && this.state.activity.id
    }

    if (this.state.selectedEntityForActivity instanceof Property) {
      activity.propertyId = this.state.selectedEntityForActivity.id;
    }

    if (this.state.selectedEntityForActivity instanceof Unit) {
      activity.unitId = this.state.selectedEntityForActivity.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...activity
        },
        onSuccess: (activity) => {
          if(status){  //if we use request(status === true) for change status, we dont redirect back we just finished funcion.
            this.setState({
              isSaving: false
            });
            this.initializePage(activity);
            return;
          }

          if (this.state.nextPath) {
            return this.redirect(this.state.nextPath);
          }

          this.redirectBack();
        },
        onError: () => {
          if(status){
            return;
          }
          this.setState({
            isSaving: false,
            hasModifiedData: true
          });
        }
      });
    });
  }

  public updateStatus = () => {
    this.setState({
      reacted: true
    },() => {
      if(!this.state.hasModifiedData){
        this.save(true);
      }
    });
  }

  public openChangeActivityStatus = () => {
    if(this.state.reacted){
      this.setState({
        reacted: false
      }, () => {
        if(!this.state.hasModifiedData){
          this.save(true);
        }
      });
    } else {
      this.setState({
        isCloseActivityPopupOpen: true
      });
    }
  } 


  protected openMenu = (event: any, task: EventInterface): void => {
    this.currentTask = task;

    this.setState({
      currentTask: task,
      anchorElTask: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorElTask: null
    });
  }

  public deleteTask = (task: EventInterface) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: task
      },
      onSuccess: () => {
        this.fetchEntityEvents(this.state.activity && this.state.activity.id);
      }
    });
  }

  public changeTaskStatus = () => {
    let selectedEntityForTask;
    if(!this.state.currentTask) {
      return;
    }
    const task: any = {
      id: !!this.state.currentTask && this.state.currentTask.id,
      content: {
        name: this.state.currentTask.content && this.state.currentTask.content.name,
        details: this.state.currentTask.content && this.state.currentTask.content.details,
      },
      executorId: this.state.currentTask.executorId,
      executionDate: this.state.currentTask.executionDate ? Time.formatOrNull(this.state.currentTask.executionDate) : null,
      snoozedDate: this.state.currentTask.snoozeDate ? Time.formatOrNull(this.state.currentTask.snoozeDate) : null,
      reporterId: this.state.currentTask.reporterId,
      eventTypeId: 35, // task
      reacted: !this.state.currentTask.reacted
    };

    if (selectedEntityForTask instanceof Property) {
      task.propertyId = selectedEntityForTask.id;
    }

    if (selectedEntityForTask instanceof Unit) {
      task.unitId = selectedEntityForTask.id;
    }

    if (selectedEntityForTask instanceof Charge) {
      task.chargeId = selectedEntityForTask.id;
    }

    if (selectedEntityForTask instanceof Event) {
      task.eventId = selectedEntityForTask.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...task
        },
        onSuccess: () => {
          this.setState({
            anchorElTask: null,
            isSaving: false,
          },() => {
            this.fetchEntityEvents(this.state.activity?.id);
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public getTasks = () => {
    return this.state.events.filter(event => event.eventTypeId === 35 || event?.eventTypeId === 38)
      .sort((task1, task2) => {
        if (!task1.content || !task2.content) {
          return 0;
        }

        if (task1.content.name.toLowerCase() > task2.content.name.toLowerCase()) {
          return 1;
        }

        if (task1.content.name.toLowerCase() < task2.content.name.toLowerCase()) {
          return -1;
        }

        return  0;
      })
      .map((task: EventInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => this.redirect(`/app/task/update/${task.id}`)}
          >
            <TableCell style={{width: "24px", paddingLeft: "24px", paddingRight: "0px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  className="icon icon-ic-task"
                  style={{
                    color: task.reacted ? "" :
                            task.executionDate &&
                            Time.formatOrNull(new Date(task.executionDate)) < Time.formatOrNull(new Date()) ?
                              "red" : "#00BCD4"
                  }}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{width: "15%"}}>{!!task.executionDate && this.formatter.formatDate(new Date(task.executionDate))}</TableCell>
            <TableCell style={{width: "15%"}}>{!!task.content && task.content.name}</TableCell>
            <TableCell >{!!task.object && task.object.displayName}</TableCell>
            <TableCell>{task && task.executor ? `${task.executor.firstName} ${task.executor.lastName}` : ""}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, task)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElTask}
                  open={Boolean(this.state.anchorElTask) && this.state.currentTask && this.state.currentTask.id === task.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={this.changeTaskStatus}
                  >
                    <ListItemIcon><div className={`icon icon-ic-${this.state.currentTask && this.state.currentTask.reacted ? "reopen" : "close" } aligned`}></div></ListItemIcon>
                    <ListItemText>{this.state.currentTask && this.state.currentTask.reacted ? this.trans("menu/status-option/open") : this.trans("menu/status-option/close")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.redirect(`/app/task/update/${this.currentTask && this.currentTask.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.setState({isDeleteTaskPopupOpen: true, anchorElTask: null})}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public renderInfoTab = () => {
    return (
      <div>
        {
          !this.state.isFetchingActivity && 
          this.state.events.filter(event => (event.eventTypeId === 35 || event?.eventTypeId === 38) && !event.reacted).length > 0 && (
            <div className="component-wrapper no-margins has-margin-bottom">
              <div className="component">
                <Card className="card" style={{padding: "20px 20px 20px 65px"}}>
                    <p className="hint-styles" style={{color: "#333", margin: "0"}}>
                      {this.trans("page/activitydetails-hint/opentasksnumber", {
                        numberOfOpenTasks: this.state.events.filter(event => (event.eventTypeId === 35 || event?.eventTypeId === 38) && !event.reacted).length
                      })
                      }
                    </p>
                </Card>
              </div>
            </div>
          )
        }

        <div className="component-wrapper no-margins has-margin-bottom">
          <div className="component">
            {
              this.state.isFetchingActivity && (
                <div style={{position: "relative", height: "60px"}}>
                  <div className="component-spinner-wrapper">
                    <CircularProgress />
                  </div>
                </div>
              )
            }

            {
              !this.state.isFetchingActivity && (
                <Card className="card">
                  <div className="read-only-wrapper">
                    <div className="name-field">
                      <div className="margin-wrapper">
                        {this.state.name && <div>{`${this.trans("label-type")}: `}</div>}
                        {this.state.selectedEntityForActivity && this.state.selectedEntityForActivity.nameOfEntity && <div>{`${this.state.selectedEntityForActivity.nameOfEntity}: `}</div>}
                        {this.state.selectedEntityForActivity && (this.state.ownerId || this.state.tenantId)  &&  <div>{this.state.selectedEntityForActivity instanceof Property ? <div>{`${this.trans("owner")}: `}</div> : this.state.selectedEntityForActivity && <div>{`${this.trans("tenant")}: `}</div>}</div>}
                        {this.state.activity && this.state.activity.creator && <div>{`${this.trans("registered-by")}: `}</div>}
                      </div>
                    </div>
                    <div className="margin-wrapper" style={{maxWidth: "80%", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}>
                      {this.state.name && <div style={{maxWidth: "340px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}>{this.state.name}</div>}
                      {this.state.selectedEntityForActivity && this.state.selectedEntityForActivity.nameOfEntity  && <div className="link-to-entity" onClick={() => this.redirect(`/app/${this.state.selectedEntityForActivity.nameForUrl}/update/${this.state.selectedEntityForActivity.id}`)}>{this.state.selectedEntityForActivity ? `${this.state.selectedEntityForActivity.displayName}` : ""}</div>}
                      {this.state.selectedEntityForActivity && (this.state.owner || this.state.tenant) && this.state.selectedEntityForActivity instanceof Property ? <div className="link-to-entity" onClick={() => this.redirect(`/app/owner/update/${this.state.owner && this.state.owner.id}`)}>{this.state.owner && this.state.owner.name}</div> : <div className="link-to-entity" onClick={() => this.redirect(`/app/person/update/${this.state.tenant && this.state.tenant.id}`)}>{this.state.tenant && this.state.tenant.firstName + this.state.tenant.lastName}</div>}
                      <div className="link-to-entity" onClick={() => this.redirect(`/app/user/update/${this.state.activity && this.state.activity.createdBy}`)}>
                        {this.state.activity && this.state.activity.creator && this.state.activity.creator.displayName}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="grid"></div>
                    <div className="grid">
                      <div style={{position: "absolute", right: "0", top: "0"}}>
                        <FormControlLabel
                          control={
                            <Switch
                              checked={this.state.reacted}
                              onChange={this.openChangeActivityStatus}
                              color="primary"
                            />
                            }
                          label={this.trans("status-closed")}
                        />
                      </div>

                      <PersonLookup
                        {...this.props}
                        autoSelectId={this.state.reporterId}
                        isInlineBlock={true}
                        width="100%"
                        containerWidth="100%"
                        ref="PersonLookup"
                        floatingLabelText={this.trans("reported-by") + this.trans("field/optional")}
                        labelText={this.trans("reported-by") + this.trans("field/optional")}
                        onSelect={this.selectReporter}
                        onClear={this.clearReporter}
                        forceUpdatePage={true}
                        saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "activityCreate", "reporter")}
                        buttonLabel={this.trans("button-add-person")}
                        noResultText={this.trans("dropdown-person-notfound")}
                        templateFor={"person"}
                        includeUsers={true}
                      />

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-subject"
                        type="text"
                        label={this.trans("subject") + this.trans("field/optional")}
                        value={this.state.subject}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "subject")}
                        autoFocus={true}
                        variant="standard"
                        style={{marginBottom: "10px"}}
                        error={!!this.getErrorFor("subject")}
                      />
                      {!!this.getErrorFor("subject") && <div className="component-error-text">{this.getErrorFor("subject")}</div>}

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-description"
                        type="text"
                        label={this.trans("description") + this.trans("field/optional")}
                        value={this.state.description}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "description")}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        error={!!this.getErrorFor("description")}
                      />
                      {!!this.getErrorFor("description") && <div className="component-error-text">{this.getErrorFor("description")}</div>}
                    </div>
                  </div>
                </Card>
              )
            }
          </div>
        </div>

        <div className="component-wrapper no-margins has-margin-bottom">
          <Card className="card no-padding">
            <div className="label-container">
              <h3 className="card-title">
                {this.trans("tasks")}
              </h3>

              <Button
                color="primary"
                onClick={() => this.setState({isNewTaskPopupOpen: true})}
              >
                {this.trans("new-task")}
              </Button>
            </div>
            <div>
              <TableComponent
                {...this.props}
                className="listing-table tasks-listing-table with-first-border"
                rows={this.getTasks()}
                subtitle={this.trans("title-no-tasks-to-list")}
              />
            </div>
          </Card>
        </div>

        <div className="component-wrapper no-margins has-margin-bottom">
          <Attachment
            {...this.props}
            typeOfComponent="shared"
            title={this.trans("attachments-for-activity")}
            amazonFolderName={this.state.amazonFolderName}
            relation="eventId"
            entity={this.state.activity}
            attachments={this.state.attachments}
            onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
            onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
            updateParentState={attachments => this.setState({attachments: attachments})}
            disabled={this.state.removed}
          />
        </div>
      </div>
    );
  }

  public renderFinanceTab = () => {
    return (
      <div className="component-wrapper no-margins has-margin-bottom">
        <Card className="card no-padding">
          <div className="label-container">
            <h3 className="card-title">
              {this.trans("balance-for-activity")}
            </h3>

            <Button
              color="primary"
              onClick={() => {
                if (this.checkProcessIsBusy({
                                  action: "create",
                                  entityName: "charge",
                                  entity: this.state.activity
                                })) {
                  this.openIsBusyPopup();
                } else {
                  this.props.dispatch({
                    type: Constants.PAGE_CHARGE_CREATE_ADD_PARAMS,
                    payload: {
                      eventId: this.state.activity.id
                    }
                  });

                  // this.openChargeCreatePopup();
                  this.setState({
                    isCoachNewChargeOpen: true
                  });
                }
              }}
              disabled={this.state.removed}
            >
              {this.trans("button-add-charge")}
            </Button>
          </div>

          <BalanceComponent
            {...this.props}
            balanceFor="activity"
            balanceCharges={this.state.charges}
            deleteCharge={this.deleteCharge}
            fetchCharges={() => {
              this.fetchActivityCharges(this.state.activity.id);
            }}
            eventId={this.state.activity.id}
          />
        </Card>
      </div>
    );
  }

  public fetchActivityCharges = (activityId: number) => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        eventId: activityId,
        isAfterStartDate: 1, // do not fetch charges before start date
      },
      onSuccess: data => {
        this.setState({charges: [...data.charges]});
      }
    });
  }

  public deleteCharge = (charge: ChargeInterface): any => {
    this.setState({
      isSaving: true
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_DELETE_START,
        payload: {
          charge: charge
        },
        onSuccess: res => {
          this.fetchActivityCharges(this.state.activity.id);
  
          this.setState({
            deletedCharge: charge,
            removedPayments: res.data.data.removedPayments,
            paymentsFailedToRemove: res.data.data.paymentsFailedToRemove,
            isSaving: false
          }, () => {
            if (this.state.deletedCharge && this.state.deletedCharge.amountPaid > 0 && this.state.removedPayments.length === 0) {
              this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.trans("textfield-charge-was-deleted-you-can-find-payments"),
                  type: "info"
                }
              });
            }
          });
        }
      });
    });
  }

  public switchTab = (event, tabValue): any => {
    event

    this.setState({
      selectedTabIndex: tabValue
    });

    // this.props.dispatch({
    //   type: Constants.PAGE_ACTIVITY_UPDATE_SWITCH_TAB,
    //   payload: {
    //     index: tabValue
    //   }
    // });
  }


  public openMenuActivity = (event: any, activity: EventInterface): void => {
    this.setState({
      currentActivity: activity,
      anchorElActivity: event.currentTarget
    });
  }

  public closeMenuActivity = (): void => {
    this.setState({
      anchorElActivity: null
    });
  }

  public changeActivityStatus = () => {
    let selectedEntityForActivity;
    const activity: any = {
      eventTypeId: 34,
      reacted: !this.state.activity.reacted,
      reporterId: this.state.activity.reporterId,
      content: {
        name: this.state.activity.content && this.state.activity.content.name,
        subject: this.state.activity.content && this.state.activity.content.subject,
        description: this.state.activity.content && this.state.activity.content.description
      },
      amazonFolderName: this.state.activity.amazonFolderName,
      id: this.state.activity && this.state.activity.id
    }
    if (!!this.state.activity && this.state.activity.property) {
      selectedEntityForActivity = this.state.activity.property;
    }


    if (!!this.state.activity && this.state.activity.unit) {
      selectedEntityForActivity = this.state.activity.unit;
    }

    if (selectedEntityForActivity instanceof Property) {
      activity.propertyId = selectedEntityForActivity.id;
    }

    if (selectedEntityForActivity instanceof Unit) {
      activity.unitId = selectedEntityForActivity.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...activity
        },
        onSuccess: () => {
          this.setState({
            anchorElActivity: null,
            isSaving: false,
          })
        },
        onError: () => {
          this.setState({
            isSaving: false,
          });
        }
      });
    });
  }

  public deleteActivity = (activity: EventInterface) => {
    this.setState({
      isSaving: true,
      anchorElActivity: null
    })
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: activity
      },
      onSuccess: () => {
        this.setState({
          isSaving: false
        }, this.redirectBack)
      }
    });
  }

  public openChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: true
    });
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <div className="title-wrapper">
                <h1>{this.trans("activity")}</h1>
              </div>
              <div className="button-container">
                {
                  this.state.hasModifiedData && (
                    <Button
                      color="primary"
                      onClick={this.redirectBack}
                      style={{marginRight: "20px"}}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                  )
                }
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {this.state.hasModifiedData ? this.save(false) : this.redirectBack()}}
                  disabled={this.state.isSaving}
                >
                  {this.state.hasModifiedData ? this.trans("button-save") : this.trans("label-done")}
                </Button>
                {
                  <div className="three-dot-entity-menu">
                  <IconButton
                    onClick={e => this.openMenuActivity(e, this.state.activity)}
                  >
                  <div className="icon icon-ic-more-vert"></div>
                  </IconButton>
                    <Menu
                      id="simple-menu"
                      anchorEl={this.state.anchorElActivity}
                      open={Boolean(this.state.anchorElActivity) && this.state.activity && this.state.activity.id === this.state.activity.id}
                      onClose={this.closeMenuActivity}
                      disableAutoFocusItem={true}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center"
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                      }}
                      getContentAnchorEl={null}
                    >
                      <MenuItem
                        onClick={() => this.setState({isDeleteActivityPopupOpen: true, anchorEl: null})}
                      >
                        <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                        <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                      </MenuItem>
                    </Menu>
                  </div>
                }
              </div>
            </div>
          </div>

          <div className="box component-property-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div style={{position: "relative"}}>
                <Tabs
                  className="tab tab-simple tab-contains-2 half-size has-margin-bottom"
                  value={this.state.selectedTabIndex}
                  onChange={this.switchTab}
                >
                  <Tab label={this.trans("label-overview")} value={0} />
                  <Tab label={this.trans("label-finance")} value={1}
                    onClick={() => this.fetchActivityCharges(this.state.activity && this.state.activity.id)}
                  />
                </Tabs>
              </div>
              {this.state.selectedTabIndex === 0 && this.renderInfoTab()}
              {this.state.selectedTabIndex === 1 && this.renderFinanceTab()}
            </div>
          </div>

          { this.isBeta() && 
            <Timeline
              {...this.props}
              relations={{ refersToEventId: this.state.activity && this.state.activity.id }}
              entityEvents={this.state.events}
              fetchEntityEvents={this.fetchEntityEvents.bind(this, this.state.activity && this.state.activity.id)}
              fetchingEvents={this.state.fetchingEvents}
              activity={this.state.activity}
            />
          }
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(false); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("delete-task")}
          content={this.trans("you-are-about-to-delete-task", {name: this.currentTask ? this.currentTask.name ? this.currentTask.name : "" : ""})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteTaskPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteTaskPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteTaskPopupOpen: false }); this.deleteTask(this.currentTask) }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("delete-activity")}
          content={this.trans("you-are-about-to-delete-activity", {name: this.state.activity && this.state.activity.name ? this.state.activity.name : ""})}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteActivityPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteActivityPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteActivityPopupOpen: false }); this.deleteActivity(this.state.activity) }}
          positiveButtonStyle={{backgroundColor:"red"}}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/warning-title")}
          content={this.trans("page/activitydetails-dilalog/checkclosedstatus-info")}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("page/activitydetails-dilalog/checkclosedstatus-button/close")}
          openLeavePrompt={this.state.isCloseActivityPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isCloseActivityPopupOpen: false })}}
          onSave={() => { this.setState({ isCloseActivityPopupOpen: false, }); this.updateStatus();}
          }
          positiveButtonStyle={{backgroundColor:"red"}}
        />

        <ChargeCreateDialog 
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          selectedEntity={this.state.activity}
          onCancel={this.closeChargeCreatePopup}
          {...this.props}
        />

        {this.state.isCoachNewChargeOpen && (
        <CoachNewCharge
          {...this.props}
          openCoach={this.state.isCoachNewChargeOpen}
          selectedObjectForNewCharge={this.state.activity}
          onCloseCoach={(success: boolean = false, charge) => {
            this.setState({
              isCoachNewChargeOpen: false
            }, () => {
              if (success) {
                return this.redirect(`/app/charge/update/${charge.id}`)
              }
            })
          }}
          selectedOwnerForNewCharge={this.state.activity?.unit?.property?.company}
          defaultChargeTypeId={TypeContainer.pickIdFromLabel("Other_receivable")}
          defaultChargeTypeLabel={"Other_receivable"}
        />
        )}

        <CreateTaskDialog 
          {...this.props}
          entity={this.state.activity}
          isOpen={this.state.isNewTaskPopupOpen}

          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false, 
              anchorEl: null
            })
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    charges: state.charges,
    properties: state.properties,
    units: state.units,
    component: state.activityUpdate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  ActivityUpdate
);
